import { GalleryUploader } from "../gallery-uploader/gallery-uploader";

/**
 * Check buttons list component script
 */
export const FileDropper = (function () {
  var csrfHeaders = function () {
    return {
      "x-csrf-token":
        '{"csrf_name":"' +
        $("#csrf_name").val() +
        '","csrf_value":"' +
        $("#csrf_value").val() +
        '"}',
    };
  };

  var init = function () {


    $(".file-dropper-droparea.no-init").each(function(){
      var dropArea = $(this)[0];
      var key = $(dropArea).attr('key');
    
      dropArea.addEventListener("dragenter", fileDropperHandler, false);
      dropArea.addEventListener("dragleave", fileDropperHandler, false);
      dropArea.addEventListener("dragover", fileDropperHandler, false);
      dropArea.addEventListener("drop", fileDropperHandler, false);
      dropArea.addEventListener("drop", handleDrop.bind(null, key), false);
      registerInputOnChange(key);
  
      //populate the existing background image
      if ($(dropArea).attr("data-attr-bg")) {
        $(dropArea).css(
          "background-image",
          "url(" + $(dropArea).attr("data-attr-bg") + ")"
        );
      }
  
  
      $(dropArea).on({
        mouseenter: function () {
          $(dropArea).find(".dropper-controls").animate(
            { opacity: 1 },
            300
          );
        },
        mouseleave: function () {
          $(dropArea).find(".dropper-controls").animate(
            { opacity: 0 },
            300
          );
        },
        click: function (e) {
          $(".file-dropper-droparea-files[key="+key+"]")[0].click();
          e.stopPropagation();
          return false;
        },
      });
  
      
      $(dropArea).removeClass('no-init');
    });
  };

  var handleFiles = function (files, key) {
    var fileList = [...files];
    
    fileList.forEach(function (currentValue, index, arr) {
      console.log("uploading...", currentValue);

      var formData = new FormData();
      
      var appendGalleryMode = $(".file-dropper-droparea-files[key="+key+"]").attr(
        "append-gallery"
      );
      var allFilesMode = $(".file-dropper-droparea-files[key="+key+"]").attr(
        "accept-all-files"
      );
      formData.append("file", currentValue);
      formData.append("key", key);
      formData.append("appendGalleryMode", appendGalleryMode);
      formData.append("allFilesMode", allFilesMode);

      $(".file-dropper-droparea[key="+key+"] .dropper-error").html('').addClass('d-none');

      $.post({
        url: MaMFormHandler.getBaseUrl()+"/set-value",
        contentType: false,
        processData: false,
        headers: csrfHeaders(),
        data: formData,
        success: function (res) {

          if(res.success == false){
            $(".file-dropper-droparea[key="+key+"] .dropper-error").html('Error uploading this image.').removeClass('d-none');
            return false;
          }
          
          $("#custom_input_b64-"+key).val(res.b64.split(",")[1]);
          $(".file-dropper-droparea[key="+key+"]").css(
            "background-image",
            "url('" + res.b64 + "')"
          );
          $(".file-dropper-droparea[key="+key+"]").attr("data-attr-bg", res.b64);

          $(".profile-pic-aligncenter img, .profile-pic-aligncenter svg")
            .off("click")
            .on("click", function () {

              $("#galleryDescriptionModalLabel-"+key).modal("show");

              var imageDetailsElem = $(this).closest(".profile-pic-has-image");

              $("#gallery-modal-src-"+key).css(
                "backgroundImage",
                "url(" + $(imageDetailsElem).attr("data-attr-src") + ")"
              );
              $("#gallery-modal-description-"+key).val(
                $(imageDetailsElem).attr("data-attr-description")
              );
            });

            if(appendGalleryMode){
              $(".append-gallery-results[key="+key+"]").prepend(res.html);
              var existingInputs = $('.gallery-input[data-attr-key="'+key+'"]').val();
              $('.gallery-input[data-attr-key="'+key+'"]').val(existingInputs+','+res['add-image'].response_data.last_insert_id );
              GalleryUploader.initControls();
              $('.gallery-input.bsave').trigger('blur');
            }else{
              //if successfully uploaded
              $("#profile-pic-src-" + key).attr(
                "src",
                "/static/images/profile-example.jpeg"
              );
              $("#profile-pic-container-" + key).removeClass("d-none");
              $("#profile-pic-upload-container-" + key).addClass("d-none");
              
              $('.bsave[data-attr-profilekey="'+key+'"]').trigger('blur');

              ProfilePicWideWControls.init();              
            }
        },
        complete: function (res) {
          $(".file-dropper-droparea-files[key="+key+"]")[0].value = null;


        },
      });
    });
  };

  function handleDrop(key, e) { 

    var dt = e.dataTransfer;
    var files = dt.files;

    handleFiles(files, key);

  }

  function registerInputOnChange(key) {
    $(".file-dropper-droparea-files[key="+key+"]").on("change", function () {
      handleFiles($(".file-dropper-droparea-files[key="+key+"]")[0].files, key);
    });
  }

  var fileDropperHandler = function (e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  return {
    init: init
  };
})();
